import { ToastContainer, Slide } from 'react-toastify';
import clsx from 'clsx';
import { connect } from 'react-redux';
import { useIntl } from 'react-intl';
import { Container } from 'semantic-ui-react';
import React from 'react';
import LayoutLoader from '@/layout/components/LayoutLoader';
import RibbonMenuActions from '@/components/ribbon-actions/RibbonMenuActions';
import { presentationOptions } from '@/constants/states';
import { locationInputs } from '@/constants/urls';
import withRouter from '@/routes/withRouter';
import { allowedTab, findTabByUrl } from '@/layout/layoutManagerTabs';
import { tabComponentState } from '@/layout/state/state';
import { decodeSearchQuery } from '@/search/actions';
import AppDialogs from '@/app/components/AppDialogs';

const TabPage = ({
  approved,
  currentUser,
  permissions,
  search,
  theme,
}) => {
  const intl = useIntl();
  const params = locationInputs.params();
  const url = locationInputs.hash();
  const tab = allowedTab(findTabByUrl(url), { permissions, currentUser, url });
  const display = params.get('display');
  const configuration = {
    ...tabComponentState(tab, url, { intl, search }),
    displayAs: Object.values(presentationOptions).includes(display) ? display : presentationOptions.TABLE,
  };
  const { Component, Ribbon } = tab;
  const withRibbon = approved && params.get('ribbon') === 'true' && Ribbon;
  const withToasts = approved && params.get('toasts') === 'true';
  const className = `panel-identifier ide-content aridhia-tab-panel aridhia-${tab.className}`;
  const themeParameter = params.get('theme');
  const themeAs = ['dark', 'default', 'vibrant'].includes(themeParameter) ? themeParameter : theme;
  const classes = ['ribbon', 'aridhia-ribbon', 'justify-center', 'no-full-screen', `aridhia-theme-${themeAs}`];

  return (
    <div className={`aridhia-panel-page aridhia-theme-${themeAs} aridhia-theme-root`}>
      {withToasts && (<ToastContainer transition={Slide} />)}
      <AppDialogs theme={themeAs} />
      {withRibbon && (
        <Container className={clsx(classes)}>
          <RibbonMenuActions>
            <Ribbon category={configuration.category} code={configuration.code} url={url} />
          </RibbonMenuActions>
        </Container>
      )}
      <LayoutLoader>
        <div className={clsx(className, 'aridhia-panel-page-content')}>
          <Component configuration={configuration} />
        </div>
      </LayoutLoader>
    </div>
  );
};

const mapStateToProps = ({
  auth: { currentUser, role: { permissions, approved } },
  themes: { theme },
}) => ({
  approved,
  currentUser,
  permissions,
  theme,
});

const mapDispatchToProps = {
  search: ({ query }) => decodeSearchQuery('open', null, query),
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(TabPage));
